import(/* webpackMode: "eager" */ "F:\\itc\\itcm-ialabs-chatbot-app\\src\\app\\page.tsx");
